import { useCallback, useEffect, useState } from "react";
import { useGlobalStateStore } from "../../stores/store";
import ImgSearch from "../../assets/img/close-search-btn.svg";
import debounce from "lodash/debounce";
import { loadNextOddsPage } from "../interactors/odds";

const SearchInput = ({ placeholder = "Search by team", minLength = 2 }) => {
  const store = useGlobalStateStore();
  const [isClearButtonVisible, setClearButtonVisible] = useState(false);

  const {
    getActiveTab,
    setLastLoadedPage,
    searchQuery,
    setSearchQuery,
    setIsSearching,
    isSearching,
  } = store;

  const activeTab = getActiveTab(); // ✅ Get active tab

  const debouncedSearch = useCallback(
    debounce(async (query) => {
      if (query.length >= minLength) {
        setIsSearching(true);
        setLastLoadedPage(activeTab, 0); // ✅ Reset only for current tab

        loadNextOddsPage(store, {
          tab: activeTab, // ✅ Make sure to search in the correct market
          onBeforeSuccess: () => {
            store.clearOddsData();
          },
          onSuccess: (itemsLoaded) => {
            store.setCanLoadMore(itemsLoaded > 0);
          },
          onFinally: () => {
            setIsSearching(false);
          },
        });
      }
    }, 300),
    [activeTab, minLength]
  );

  useEffect(() => {
    if (searchQuery.length >= minLength) {
      debouncedSearch(searchQuery);
    }

    setClearButtonVisible(searchQuery.trim() !== "");

    return () => {
      debouncedSearch.cancel();
    };
  }, [searchQuery, debouncedSearch, minLength]);

  const handleClear = () => {
    store.deactivateSearchMode();
    setSearchQuery("");

    loadNextOddsPage(store, {
      tab: activeTab, // ✅ Ensure correct market after clearing search
      onBeforeSuccess: () => store.clearOddsData(),
      onSuccess: (itemsLoaded) => {
        store.setCanLoadMore(itemsLoaded > 0);
      },
    });
  };

  return (
    <>
      <input
        type="text"
        id="search-input"
        placeholder={placeholder}
        minLength={minLength}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      {isClearButtonVisible && (
        <button
          type="button"
          className={`search_modal-clear-button ${
            isClearButtonVisible ? "visible" : ""
          }`}
          onClick={handleClear}
        >
          <img alt="clear search" src={ImgSearch} />
        </button>
      )}
    </>
  );
};

export default SearchInput;
